/*
 * Seed IM - Service to manage configuration for the app stored in the repo.
 */
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

//import { HttpClient } from '@angular/common/http';
import { ContentApiService } from '@alfresco/aca-shared';

//import { AlfrescoApiService } from '@alfresco/adf-core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class OauthService {

  appConfig: any;
  ACCESS_TOKEN_KEY = 'access_token';


  constructor(

    private contentApi: ContentApiService,
    private http: HttpClient) {
  }

  getOauthAccessToken(): string | null {

    // Retrieve the access token from localStorage
    const accessToken = localStorage.getItem(this.ACCESS_TOKEN_KEY);
    //const accessToken = "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI2QUZUQl9ILW1UWjJZQ3ppUG0zbndrSHM5cHRqSG9DN055YndZUlRURkRZIn0.eyJleHAiOjE3Mzc1MzQzMTcsImlhdCI6MTczNzUzMzQxNywiYXV0aF90aW1lIjoxNzM3NTIwMDIzLCJqdGkiOiJkYTdkZWVhNy0wZGZlLTQ5ZDEtYmEyZS0yMjI0Nzk2ZThlMWMiLCJpc3MiOiJodHRwczovL2Nhcmxpc2xlaG9tZXNkZXYuYWxmcmVzY29jbG91ZC5jb20vYXV0aC9yZWFsbXMvYWxmcmVzY28iLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiMjkyZjE0YzQtNGRiMi00MTFhLTkwODAtYzQ0Y2RjZjU0MGIxIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiYWxmcmVzY28iLCJub25jZSI6IkZiOEN6eVkzYlpQRENVSTRuZENJQThOUTZCRDlDVHA5dG5ydVQ5OXEiLCJzZXNzaW9uX3N0YXRlIjoiZDQ0NzZhMTEtMzg2OS00NGUzLThlZjItMDEwYTk2ZmYwNzM3IiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHBzOi8vZ3JlZW4tY2FybGlzbGVob21lc2Rldi5hbGZyZXNjb2Nsb3VkLmNvbSIsImh0dHBzOi8vY2FybGlzbGVob21lc2Rldi1hcGEuYWxmcmVzY29jbG91ZC5jb20iLCJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20iLCJodHRwczovL2Nhcmxpc2xlaG9tZXNkZXYtaW5nZXN0aW9uLmFsZnJlc2NvY2xvdWQuY29tIiwiaHR0cDovLzEyNy4wLjAuMSIsImh0dHA6Ly9sb2NhbGhvc3QiLCJodHRwczovL2Nhcmxpc2xlaG9tZXNkZXYuYWxmcmVzY29jbG91ZC5jb20iLCJodHRwczovL2Nhcmxpc2xlaG9tZXNkZXYtYXBwLmFsZnJlc2NvY2xvdWQuY29tIl0sInJlYWxtX2FjY2VzcyI6eyJyb2xlcyI6WyJkZWZhdWx0LXJvbGVzLWFsZnJlc2NvIiwib2ZmbGluZV9hY2Nlc3MiLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoib3BlbmlkIGVtYWlsIHByb2ZpbGUiLCJzaWQiOiJkNDQ3NmExMS0zODY5LTQ0ZTMtOGVmMi0wMTBhOTZmZjA3MzciLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsInByZWZlcnJlZF91c2VybmFtZSI6ImNhcmxpc2xlZGV2YWRtaW4ifQ.cgsHwovwL71w4ndvu7L0cImdWA7ALmeUKMHK0LreUwXPk-nfm2P6ENMgPFywY0QRBY6fYLMK4OXv82KAYTF8nfmheN8-xi7lTvDeWM7nXRu7fKFXd4XbaWSmh4fzYycvHXEFC5LsY_6GE9nJhDAhMY-8isV-tB-6UspKg0tOm2HOH1JvJDp09XJ3hEcxAru0UXkUx9Uu7V6AwAQcsf_DdB-KjmeJO6S1vRLqbe55u1i1qTPhcZqtxRCNY_6hXREM65al67OkSZOUDNNdnoLYdY2NEOsMDfL4H6_difIK6NDazUqgmkTFBlvfdb2g0myYX66FDV59dkW-fK6z3lDT9w"
    // Check if the token exists
    if (accessToken && accessToken != null) {
        //console.log('Access token:', accessToken);
    } else {
        console.log('Access token not found');
    }
    return accessToken;
  }

    getOauthTicket(): Observable<any> {
      //console.log("getAppConfigFileNode entered");

      let accessToken = this.getOauthAccessToken();
      if(accessToken != null){

        let dns = window.location.origin.replace("-app", "");
        //dns = "https://carlislehomesdev.alfrescocloud.com";
        let apiUrl = dns + '/alfresco/api/-default-/public/authentication/versions/1/tickets/-me-';

        // Create headers with required values (e.g., Authorization, Content-Type)
        const headers = new HttpHeaders(
          {
            'Authorization': `Bearer ${accessToken}`,  // Your custom header key-value
          });

        // Pass headers as part of options to the GET request
        //const options = { headers: {headers };

        return this.http.get<any>(apiUrl, { headers });
    }

    return of(null);
  }

  getAppConfigFileContentUrl(nodeId: string): string {
    //console.log('getAppConfigFileContentUrl method', nodeId);
    return this.contentApi.getContentUrl(nodeId);
  }
  getAppConfigFileContent(nodeId: string){
    //console.log("this.getAppConfigFileContentUrl(nodeId)", nodeId);

    return this.http.get(this.getAppConfigFileContentUrl(nodeId));
  }

}
